import { composeIO } from 'react-compose-io'
import { enhancedTableHeadIO } from './EnhancedTableHead.IO'
import EnhancedTableHeadView from './EnhancedTableHead.View'

export const EnhancedTableHead = composeIO(EnhancedTableHeadView, enhancedTableHeadIO)
